export var defaultInvalidDate = 'Invalid date';

export function invalidDate () {
    return this._invalidDate;
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/locale/invalid.js